// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { serviceWorkerRegistration } from './registerServiceWorker'
import Api from './api'
import App from './App'
import router from './router'
import store from './store'
import { FontAwesomeIcon } from './icons'
import titleMixin from './mixins/titleMixin'
import VueLazyload from 'vue-lazyload'
import Constants from '@/util/constants'
import GoogleMapsApiLoader from "google-maps-api-loader"
import VueNotifications from 'vue-notification'
import { firebaseMessaging } from './firebase';

// sass mainfest file
require('./assets/sass/main.scss')

Vue.component('font-awesome-icon', FontAwesomeIcon)

serviceWorkerRegistration.initialize(firebaseMessaging);
if (firebaseMessaging) {
  Vue.prototype.$messaging = firebaseMessaging;
}

if ('serviceWorker' in navigator) {
  let isAppReloading;
  navigator.serviceWorker.addEventListener('controllerchange', function () {
    if (isAppReloading) return;
    window.location.reload();
    isAppReloading = true;
  });
}

Vue.config.productionTip = false
Vue.mixin(titleMixin)
Vue.use(VueLazyload)
Vue.use(VueNotifications)

GoogleMapsApiLoader({
  libraries: ["places", "geometry"],
  apiKey: Constants.dataMap.googleMapsAPIKey
}).then(function (googleApi) {
  Vue.prototype.$gmapApi = googleApi
}, function (err) {
  console.error(err);
});

Api.init()
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  beforeCreate() {
    this.$store.commit('user/initialize');
  },
  created() {
    const me = this;
    if (me.$store.state.user && me.$store.state.user.user) {
      setTimeout(() => {
        if (me.$messaging &&
          'Notification' in window &&
          Notification.permission === 'granted') {
          const fnUpdateToken = function () {
            me.$messaging.getToken().then(messageToken => {
              me.$store
                .dispatch("user/update", {
                  messageToken
                })
                .catch(() => { });
            }).catch(err => {
              console.log('Unable to retrieve refreshed token ', err);
            });
          };

          fnUpdateToken();

          me.$messaging.onTokenRefresh(() => {
            fnUpdateToken();
          });
        }
      }, 4000);
    }
  }
})
